import {Component, HostListener, input, output} from '@angular/core';
import {Dialog} from 'primeng/dialog';
import {Button} from 'primeng/button';
import {TranslocoPipe} from '@jsverse/transloco';

@Component({
  selector: 'app-base-dialog',
  imports: [Dialog, Button, TranslocoPipe],
  templateUrl: './base-dialog.component.html',
})
export class BaseDialogComponent {
  readonly visible = input.required<boolean>();
  readonly title = input.required<string>();
  readonly testId = input.required<string>();
  readonly width = input('50vw');
  readonly dialogStyleClass = input('');
  readonly dismissableMask = input(true);
  readonly contentPadding = input(true);
  readonly titleClass = input('');
  readonly cancelLabel = input('common.cancel');
  readonly submitLabel = input('');
  readonly submitDisabled = input(false);

  readonly visibleChange = output<boolean>();
  readonly submitted = output<void>();

  @HostListener('document:keydown.escape')
  protected onEscapeKeydown(): void {
    if (this.visible()) {
      this.close();
    }
  }

  protected close(): void {
    this.visibleChange.emit(false);
  }

  protected submit(): void {
    this.submitted.emit();
  }
}
